import { db } from '../../../integrations/firebase';
import { ref, get, child } from 'firebase/database';

// Default Fallback Rules (if DB is empty)
const DEFAULT_RULES = {
    kerala: { prepaid: 0, cod: 44 },
    tamilnadu: { prepaid: 0, cod: 44 }, // Assumption: User can change this
    restOfIndia: { prepaid: 44, cod: 44 }
};

/**
 * Fetches shipping settings from Firebase
 * Path: settings/shipping
 */
export const fetchShippingRules = async () => {
    try {
        const dbRef = ref(db);
        const snapshot = await get(child(dbRef, 'settings/shipping'));
        if (snapshot.exists()) {
            return { ...DEFAULT_RULES, ...snapshot.val() };
        }
    } catch (error) {
        console.error("Error fetching shipping rules:", error);
    }
    return DEFAULT_RULES;
};

/**
 * Calculates shipping cost based on state and payment mode.
 * @param {string} state - Customer's state
 * @param {string} paymentMode - 'Prepaid' | 'COD'
 * @param {object} rules - (Optional) Pre-fetched rules. If null, fetches fresh.
 */
export const calculateShippingCost = async (state, paymentMode, rules = null) => {
    if (!state) return 0;

    // Normalize inputs
    const cleanState = state.toLowerCase().trim();
    const isCOD = paymentMode === 'COD';
    const modeKey = isCOD ? 'cod' : 'prepaid';

    // Fetch rules if not provided
    const currentRules = rules || await fetchShippingRules();

    // 1. Zone 1: Kerala
    if (cleanState.includes('kerala')) {
        return Number(currentRules.kerala[modeKey]);
    }

    // 2. Zone 2: Tamil Nadu
    if (cleanState.includes('tamil nadu') || cleanState.includes('tamilnadu')) {
        return Number(currentRules.tamilnadu[modeKey]);
    }

    // 3. Zone 3: Rest of India
    return Number(currentRules.restOfIndia[modeKey]);
};
